import { realCallerIdService } from './real-service';

export type {
  AppointmentHistoryItem, AppointmentHistoryPage, AvailabilityStaff, CallerIdService,
  CreateCustomerRequest, CustomerBrief, DayAvailability, IncomingCall, PendingCall, QuickBookingItem,
  QuickService, RecentAppointmentsResult, SlotBusyType,
} from './types';
export const callerIdService = realCallerIdService;
